import { h } from "preact";
import styles from "./Flash.css";

const Flash = () => {
  return (
    <div class={styles.flash}>
      The highest live&nbsp;
      <br />
      weather station cam&nbsp;
      <br />
      in Wales
    </div>
  );
};

export default Flash;
